<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container text-center">

                    <div class="modalheader">
                        <h3>
                        <!-- <I name="warning" style="font-size: 60px; color: red;margin-bottom: 36px;"/> -->
                        <slot name="header"></slot>
                        </h3>
                    </div>

                    <div class="modalbody">
                        <h4>
                        <slot name="body"></slot>
                        </h4>
                    </div>

                    <div class="modalfooter text-center">
                        Vid frågor kontakta oss på <a href="mailto:support@bolagskompassen.se">support@bolagskompassen.se</a>
                    </div>

                    <!-- <div style="text-align: center;">
                        <button class="btn btn-primary btn-lg w-50" @click="$emit('close')">
                            Stäng
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'InfoModal',
    };
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 600px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
    }

    .modalheader {
        margin: 0;
    }

    .modalbody {
        margin: 20px 0;
        padding: 10px;
        max-height: 200px;
        overflow: auto;
    }

    .modalfooter {
        margin: 20px 0;
        padding: 10px;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
